import React, { useEffect, useRef } from 'react';


export type RenderHtmlElementProps = {
  element: HTMLElement | null,
  wrapper?: 'div' | 'span',
};

export const RenderHtmlElement = ({ element, wrapper = 'div' }: RenderHtmlElementProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const { current } = ref;
    if (!element) {
      return;
    }
    current!.appendChild(element);
    return () => {
      current!.removeChild(element);
    };
  }, [element]);

  return wrapper === 'div'
    ? <div ref={ref} />
    : <span ref={ref} />;
};
